var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10.59 4.59Z",
    fill: "#1C4D88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428686 11.3578C0.205471 10.1301 1.14862 9 2.39643 9H21.6036C22.8514 9 23.7945 10.1301 23.5713 11.3578L22.2986 18.3578C22.1257 19.3088 21.2974 20 20.3308 20H3.66915C2.70258 20 1.87432 19.3088 1.70141 18.3578L0.428686 11.3578Z",
    fill: "#296EC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpened);
export default __webpack_public_path__ + "static/media/folder-opened.fcb5bf53629f939063e356ea3ac9ac91.svg";
export { ForwardRef as ReactComponent };